import * as React from 'react';
import getAuthConfig from '@sdk/api/utils/getAuthConfig';

import BodyPortal from '@web/components/BodyPortal';

type Props = {
  formRef: React.MutableRefObject<any>;
  url: string;
  data?: Record<string, string>;
};

const FormSubmit = ({ formRef, url, data }: Props) => {
  const authToken = getAuthConfig();

  return (
    <BodyPortal>
      <form action={url} method="post" target="_blank" noValidate hidden ref={formRef}>
        {data
          ? Object.keys(data).map((key, index) => (
              <textarea key={index} name={key} value={data[key]} readOnly hidden></textarea>
            ))
          : null}
        <input name="Authorization" type="hidden" value={authToken} />
      </form>
    </BodyPortal>
  );
};

export default FormSubmit;
